(function () {
    'use strict';
    console.log("index js working")
    // Check to make sure service workers are supported in the current browser,
    // and that the current page is accessed from a secure origin. Using a
    // service worker from an insecure origin will trigger JS console errors. See
    // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
    var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    if ('serviceWorker' in navigator &&
        (window.location.protocol === 'https:' || isLocalhost)) {
        navigator.serviceWorker.register('service-worker.js')
            .then(function (registration) {
                // updatefound is fired if service-worker.js changes.
                registration.onupdatefound = function () {
                    // updatefound is also fired the very first time the SW is installed,
                    // and there's no need to prompt for a reload at that point.
                    // So check here to see if the page is already controlled,
                    // i.e. whether there's an existing service worker.
                    if (navigator.serviceWorker.controller) {
                        // The updatefound event implies that registration.installing is set:
                        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
                        var installingWorker = registration.installing;

                        installingWorker.onstatechange = function () {
                            switch (installingWorker.state) {
                                case 'installed':
                                    // At this point, the old content will have been purged and the
                                    // fresh content will have been added to the cache.
                                    // It's the perfect time to display a "New content is
                                    // available; please refresh." message in the page's interface.
                                    break;

                                case 'redundant':
                                    throw new Error('The installing ' +
                                        'service worker became redundant.');

                                default:
                                // Ignore
                            }
                        };
                    }
                };
            }).catch(function (e) {
            console.error('Error during service worker registration:', e);
        });
    }

    // Your custom JavaScript goes here

const routes = {
    404: '/pages/404.html',
    '/': 'pages/home.html',
    '#politica-de-privacidad': '/pages/privacy-policy.html',
    '#eliminar-datos': '/pages/delete-data.html',
    '#comoFunciona': '/pages/home.html',
    '#beneficios': '/pages/home.html',
    '#preguntasFrecuentes': '/pages/home.html'
}

const smoothFragment = new Set(['#politica-de-privacidad', '#eliminar-datos']);

const route = (event) => {
    console.log(event)
    event = event || window.event
    // event.preventDefault()
    // handleLocation()
    console.log("event.target.href: ",event.target.href)
    window.history.pushState({}, "", event.target.href)
}

const handleLocation = async  () => {
    var newFragment = window.location.hash;

    console.log("newFragment: " , newFragment )
    if (newFragment !== "") {
        console.log("smoothFragment.has(newFragment", smoothFragment.has(newFragment))
        handleFragment()
        if (smoothFragment.has(newFragment)){
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

    }else {
        handlePath()
    }

}

window.addEventListener('popstate', function(event) {
    // Aquí puedes ejecutar el código que desees cuando el usuario retrocede en el historial
    console.log('El usuario ha retrocedido en el historial');
    // window.reload()
    handleLocation()
});

window.addEventListener('hashchange', async () => {
    console.log("desfdfs")
    handleLocation()
})

const handlePath = async () => {
    const path = window.location.pathname
    console.log("path: ", path)
    const route = routes[path] || routes[404]
    console.log("route: ", route)
    const html = await fetch(route).then(data => data.text())
    document.getElementById('main-page').innerHTML = html
}
const handleFragment = async () => {
    var newFragment = window.location.hash;
    const route = routes[newFragment] || routes[404]
    const html = await fetch(route).then(data => data.text())
    const mainPage = document.getElementById('main-page')
    mainPage.innerHTML = html
    console.log("ruta: ", route)
    console.log('El fragmento de la URL ha cambiado a:', newFragment);
}

window.onpopstate = handleLocation()
window.route = ''


})();
